import $ from 'jquery';

import {
  bindClearButton,
  bindSearchDropdowns,
} from '../helper_modules/select2_form_helpers';

const searchFormElements = {
  form: $(`#search-form`),
  dropdowns: $(`#search-form select`),
  clearButton: $(`#clear-button`),
};

const shipsByDateElements = {
  form: $(`#sbd-form`),
  submit: $(`#sbd-button`),
  dateInputs: $(`#ships_by_date`),
  checkBoxes: $(`.warehouse_product, #selectAll`),
};

export default class MsbdHistoryService {
  constructor() {
    this.searchFormElements = searchFormElements;
    this.shipsByDateFormElements = shipsByDateElements;
    this.bindElements();
  }

  static init() {
    if ($(`.msbd.index`).length === 0) {
      return undefined;
    }

    return new MsbdHistoryService();
  }

  bindElements() {
    bindClearButton(this.searchFormElements);
    bindSearchDropdowns(this.searchFormElements);
  }
}
